import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-copy',
  imports: [CommonModule, TranslocoModule],
  templateUrl: './copy.component.html',
  styleUrl: './copy.component.scss',
})
export class CopyComponent {
  @Input({ required: true }) content!: string;

  public copied: boolean = false;

  public copyToClipboard(text: string): void {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      })
      .catch((err) => {
        console.error('Не вдалося скопіювати:', err);
      });
  }
}
